/**
 * 系统安全路由
 * @Description: 系统安全模块路由及完整子路由
 *
 * @Author: JZT.Oscar
 * @Date: 2018-10-12 08:54:18
 * @Last Modified by: JZT.Oscar
 * @Last Modified time: 2018-10-12 17:41:41
 */

import PageView from "@/layouts/PageView";

export default [
    {
        path: "/system/siteMgr",
        name: "站点管理",
        component: () => import("@/pages/system/siteMgr/Index"),
        icon: "none",
        meta: {
            comName: "SiteList",
            needRefresh: true
        }
    },
    {
        path: "/system/siteMgr/addSite",
        name: "添加站点",
        component: () => import("@/pages/system/siteMgr/SiteAdd"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "SiteAdd"
        }
    },
    {
        path: "/system/siteMgr/areaConfig",
        name: "区域配置",
        component: () => import("@/pages/system/siteMgr/AreaConfig"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "AreaConfig"
        }
    },
    {
        path: "/system/siteMgr/areaConfigView",
        name: "查看经营区域",
        component: () => import("@/pages/system/siteMgr/AreaConfigDet"),
        invisible: true,
        meta: {
            comName: "AreaConfigDet"
        }
    },
    {
        path: "/system/siteMgr/payConfig",
        name: "支付配置",
        component: () => import("@/pages/system/siteMgr/PayConfig"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "PayConfig"
        }
    },
    {
        path: "/system/siteMgr/payConfigView",
        name: "浏览支付配置",
        component: () => import("@/pages/system/siteMgr/PayConfigDet"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "PayConfigDet"
        }
    },
    {
        path: "/system/siteMgr/globalPayConfig",
        name: "查看支付配置",
        component: () => import("@/pages/system/siteMgr/globalPayConfig"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "globalPayConfig"
        }
    },
    {
        path: "/system/role",
        name: "角色管理",
        component: () => import("@/pages/system/role/Index"),
        icon: "none",
        meta: {
            comName: "RoleList",
            needRefresh: true
        }
    },
    {
        path: "/system/role/addrole",
        name: "增加角色",
        component: () => import("@/pages/system/role/AddRole"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "RoleAdd"
        }
    },
    {
        path: "/system/role/editrole",
        name: "编辑角色",
        component: () => import("@/pages/system/role/AditRole"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "RoleEdit"
        }
    },
    {
        path: "/system/role/checkrole",
        name: "查看角色",
        component: () => import("@/pages/system/role/CheckRole"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "RoleDet"
        }
    },
    {
        path: "/system/account",
        name: "账号管理",
        component: () => import("@/pages/system/accountMgr/Index"),
        icon: "none",
        meta: {
            comName: "UserList",
            needRefresh: true
        }
    },
    {
        path: "/system/account/creatUser",
        name: "添加账号",
        component: () => import("@/pages/system/accountMgr/CreatUser"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "UserAdd"
        }
    },
    {
        path: "/system/account/editUser",
        name: "编辑账号",
        component: () => import("@/pages/system/accountMgr/EditUser"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "UserEdit"
        }
    },
    {
        path: "/system/account/resetuserpsw",
        name: "修改账号密码",
        component: () => import("@/pages/system/accountMgr/ResetUserPsw"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "UserResetPsw"
        }
    },
    // {
    //     path: "/system/tree",
    //     name: "通用搜索树示例",
    //     invisible: true,
    //     component: () => import("@/pages/system/siteMgr/Tree"),
    //     icon: "none"
    // },
    {
        path: "/system/menuMgr",
        name: "菜单管理",
        component: () => import("@/pages/system/menuMgr/Index"),
        icon: "none",
        meta: {
            comName: "MenuList",
            needRefresh: true
        }
    },
    {
        path: "/system/shopMenu",
        name: "店铺菜单管理",
        component: () => import("@/pages/system/shopMenu/Index"),
        icon: "none",
        meta: {
            comName: "ShopMenuList",
            needRefresh: true
        }
    },
    {
        path: "/system/shopMenu/EditShopMenu",
        name: "编辑店铺菜单",
        component: () => import("@/pages/system/shopMenu/EditShopMenu"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "ShopMenuEdit"
        }
    },
    {
        path: "/system/shopMenu/ViewShopMenu",
        name: "查看店铺菜单",
        component: () => import("@/pages/system/shopMenu/ViewShopMenu"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "ShopMenuDet"
        }
    },
    {
        path: "/system/shopMenu/BatchShopMenu",
        name: "批量编辑店铺菜单",
        component: () => import("@/pages/system/shopMenu/BatchShopMenu"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "ShopMenuBatchEdit"
        }
    },
    {
        path: "/system/systemNotice",
        name: "系统公告",
        component: () => import("@/pages/system/systemNotice/Index"),
        icon: "none",
        meta: {
            comName: "NoticeList",
            needRefresh: true
        }
    },
    {
        path: "/system/systemNotice/add",
        name: "添加公告",
        component: () => import("@/pages/system/systemNotice/Add"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "NoticeAdd"
        }
    },
    {
        path: "/system/systemNotice/edit",
        name: "编辑公告",
        component: () => import("@/pages/system/systemNotice/Edit"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "NoticeEdit"
        }
    },
    {
        path: "/system/systemNotice/detail",
        name: "查看公告",
        component: () => import("@/pages/system/systemNotice/Detail"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "NoticeDet"
        }
    },
    {
        path: "/system/shopMgr",
        name: "店铺管理",
        component: () => import("@/pages/system/shopMgr/Index"),
        icon: "none",
        meta: {
            comName: "ShopList",
            needRefresh: true
        }
    },
    {
        path: '/system/shopMgr/netplatform-config',
        name: '挂网服务配置',
        component: () => import('@/pages/system/shopMgr/netplatform-config'),
        icon: 'none',
        meta: { comName: 'netplatformConfig' }
    },
    {
        path: "/system/shopMgr/shopAuthInfo",
        name: "查看店铺认证信息",
        component: () => import("@/pages/system/shopMgr/shopAuthInfo"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopAuthInfoDet"
        }
    },
    {
        path: "/system/shopMgr/shopAuthInfoCheck",
        name: "审核店铺认证信息",
        component: () => import("@/pages/system/shopMgr/shopAuthInfoCheck"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopAuthInfoCheck"
        }
    },
    {
        path: "/system/shopMgr/shopBasicInfoView",
        name: "查看店铺基础信息",
        component: () => import("@/pages/system/shopMgr/shopBasicInfo"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopBasicInfoDet"
        }
    },
    {
        path: "/system/shopMgr/shopBasicInfoConfig",
        name: "配置店铺基础信息",
        component: () => import("@/pages/system/shopMgr/shopBasicInfoConfig"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopBasicInfoEdit"
        }
    },
    {
        path: "/system/shopMgr/shopUpdateInfoView",
        name: "查看店铺更新信息",
        component: () => import("@/pages/system/shopMgr/ShopUpdateInfo"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopUpdateInfoDet"
        }
    },
    {
        path: "/system/shopMgr/shopUpdateInfoCheck",
        name: "审核店铺认证更新",
        component: () => import("@/pages/system/shopMgr/ShopUpdateInfoCheck"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopUpdateInfoCheck"
        }
    },
    {
        path: "/system/shopMgr/shopUpdateInfoRollback",
        name: "撤回店铺更新信息",
        component: () => import("@/pages/system/shopMgr/ShopUpdateInfoCancel"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopUpdateInfoCancel"
        }
    },
    {
        path: "/system/shopMgr/shopUpdateInfo",
        name: "更新店铺认证信息",
        component: () => import("@/pages/system/shopMgr/ShopUpdateAuth"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopAuthInfoUpdate"
        }
    },
    {
        path: "/system/shopMgr/shopTransmit",
        name: "店铺转发",
        component: () => import("@/pages/system/shopMgr/ShopTransmit"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopTransmit"
        }
    },
    {
        path: "/system/shopMgr/shopHomeInfo",
        name: "配置店铺首页",
        component: () => import("@/pages/system/shopMgr/shopHomeInfo"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopHomeInfoEdit"
        }
    },
    {
        path: "/system/shopMgr/shopProdFloor",
        name: "新增楼层",
        component: () => import("@/pages/system/shopMgr/shopProdFloor"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopProdFloorAdd"
        }
    },
    {
        path: "/system/shopMgr/shopProductSet",
        name: "配置店铺商品",
        component: () => import("@/pages/system/shopMgr/shopProductSet"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopProductSetEdit"
        }
    },
    {
        path: "/system/shopMgr/shopNumConfig",
        name: "中金支付配置",
        component: () => import("@/pages/system/shopMgr/shopNumConfig"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopNumConfig"
        }
    },
    {
        path: "/system/shopMgr/shopCommissionConfig",
        name: "积分配置",
        component: () => import("@/pages/system/shopMgr/shopCommissionConfig"),
        invisible: true,
        icon: "none",
        meta: {
            comName: "shopCommissionConfig"
        }
    }
];



// WEBPACK FOOTER //
// ./src/router/system.js